import styled from "styled-components";
import { theme } from "../../theme";

export const StyledFileUploader = styled.div`
  margin: 16px 0 30px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  label {
    background-color: ${theme.backgroundColor.primaryWhite};
    color: ${theme.backgroundColor.primaryBlack};
    padding: 10px 20px;
    border: 2px solid ${theme.backgroundColor.primaryBlack};
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    &:hover {
      background-color: ${theme.backgroundColor.primaryBlack};
      color: ${theme.backgroundColor.primaryWhite};
      transition: all 0.2s ease-in-out;
    }
  }
  svg {
    width: 25px;
    height: 25px;
    margin-left: 15px;
    cursor: pointer;
  }
`;
